module.exports = __webpack_public_path__ + "img/user-union.e39c5636.svg";